/* eslint-disable no-magic-numbers */

import {
	dimensions,
	filesize,
	duration
} from "widgets/forms/validators/Assets";
import { requiredAsset, validateUnlessExternalRender, requiredAfterEffectsComp } from "social/validators/validators";
import {
	isProtocolOptionalURL,
	isURL,
	maxLength,
	requiredNotNull
} from "widgets/forms/validators/validators";
import { uniquePACVariableName } from "widgets/social2/validators/utils";

import {
	MAX_VIDEO_BYTES,
	MAX_THUMBNAIL_BYTES,
	MIN_VIDEO_SEC,
	MAX_VIDEO_MIN
} from "./consts";

export const staticValidators = {
	video: [uniquePACVariableName],
	thumbnail: [uniquePACVariableName],
	headline: [uniquePACVariableName],
	primaryText: [uniquePACVariableName],
	landingPage: [uniquePACVariableName],
	displayLink: [uniquePACVariableName],
};

export const validators = {
	afterEffectsComposition: [
		requiredAfterEffectsComp
	],
	video: validateUnlessExternalRender([
		requiredAsset,
		filesize({ max: MAX_VIDEO_BYTES }),
		dimensions({ minWidth: 120, minHeight: 120 }),
		duration({ min: MIN_VIDEO_SEC, max: MAX_VIDEO_MIN * 60 }),
	]),
	thumbnail: validateUnlessExternalRender([
		filesize({ max: MAX_THUMBNAIL_BYTES }),
	]),
	landingPage: [
		requiredNotNull,
		isURL,
		maxLength(800),
	],
	displayLink: [isProtocolOptionalURL],
};
